import { AxiosResponse } from "axios"
import { axiosInstance, MessageResponse } from "./common"

export enum InterviewMode {
    IN_PERSON = "IN_PERSON",
    VIDEO_CALL = "VIDEO_CALL",
    PHONE = "PHONE"
}

export const interviewModeNames:{[key in InterviewMode]: string} = {
    'IN_PERSON': "In Person",
    'PHONE': "Phone",
    'VIDEO_CALL': "Video Call"
}

export interface Interview {
    case_id?: string
    id?: string
    interviewee_name?: string
    interviewee_type: string
    date: string
    mode: InterviewMode
    investigator_email: string
    findings: string
    evidence_links: string[]
}

export interface CreateInterviewRequest {
    interviews: Interview[]
}

export interface UpdateInterviewRequest {
    interviewee_type?: string
    interviewee_name?: string
    date?: string
    mode?: InterviewMode
    investigator_email?: string
    findings?: string
    evidence_links?: string[]
}
    

const InterviewsAPI = {
    create: async (request: CreateInterviewRequest) => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.post('/v1/interviews', request);
        return response.data;
    },

    update: async (caseId: string, id: string, request: UpdateInterviewRequest) => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.patch(`/v1/cases/${caseId}/interviews/${id}`, request);
        return response.data;
    }
}

export default InterviewsAPI;